class PersonalizeWrapper extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      designOpt: '[data-design-opt]',
      colorOpt: '[data-color-opt]',
      textOpt: '[data-text-opt]',
      toggleBtn: '.personalize-toggle',
      fieldsWrapper: '.personalize-fields'
    };
  }

  connectedCallback() {
    const toggleBtn = this.querySelector(this.selectors.toggleBtn);
    const fields = this.querySelector(this.selectors.fieldsWrapper);
    const petNameInput = this.querySelector(this.selectors.textOpt);
    console.log(toggleBtn, fields, petNameInput);
    // Initialize fields collapsed
    fields.style.maxHeight = '0px';
    fields.style.overflow = 'hidden';
    fields.style.transition = 'max-height 0.3s ease';

    toggleBtn.addEventListener('click', () => {
      if (toggleBtn.classList.contains('active')) { toggleBtn.classList.remove('active'); fields.style.maxHeight = '0px'; } else { fields.style.maxHeight = fields.scrollHeight + 'px'; toggleBtn.classList.add('active'); console.log(fields.scrollHeight, " fields.scrollHeightfields.scrollHeightfields.scrollHeightfields.scrollHeight");}
    });

    petNameInput.addEventListener('input', (e) => {
      let label = this.querySelector('label[for="what-is-your-pets-name?"]');
      let span = label.querySelector('span');
      if (!span) {
        span = document.createElement('span');
        span.style.marginLeft = '10px';
        label.appendChild(span);
      }
      span.style.display = e.target.value.length ? 'inline' : 'none';
      span.textContent = `${e.target.value.length} | 25`;
    });
  }
}

customElements.define('personalize-wrapper', PersonalizeWrapper);
